// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"287e90e1","453":"67d1943e"}[chunkId] + ".chunk.js";
};